import LeverageLogo from '@/assets/branding/leverage/leverage-logo.png';

export default {
  name: 'Leverage',
  isSAML: true,
  allowPersonalCourses: false,
  logo: LeverageLogo,
  colors: {
    // Brand colors
    brand_primary: '#143359',
    brand_primary_hover: '#0D1B2D', // −10 L, −8 S
    brand_primary_highlight: '#2269C1', // +23 L, +7 S
    brand_primary_mid: '#1A467C', // +8 L,  +2 S
    brand_primary_dark: '#000000', // −25 L, −3 S (clamped)
    brand_secondary: '#080E18', // hue +4°, −15 L, −13 S
  },
};
